import { Box, Image } from "@jewlr/storybook/core"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { useEffect, useRef } from "react"
import { connect } from "react-redux"

import { updateDiamond } from "areas/product/store/actions"
import {
  OptionsSlider,
  OptionTitle,
  OptionPrice,
} from "areas/product/wizard-options/components"
import { to_currency } from "helpers/number"
import { useNavigation } from "helpers/use-navigation"

import { ChoiceOption } from "./components"

const ChoiceOptions = ({
  focusElementRef,
  caratOptions,
  selectedCarat,
  selectedShape,
  setChoice,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider aria-labelledby="diamond-selector-d_carat" role="radiogroup">
      {caratOptions.map((carat, i) => {
        const selected = selectedCarat === carat.value
        const focused = selectedCarat ? selected : i === 0
        const price =
          carat.min_price === carat.max_price
            ? to_currency(carat.max_price)
            : `${to_currency(carat.min_price)} to ${to_currency(
                carat.max_price
              )}`

        return (
          <ChoiceOption
            aria-checked={selected}
            aria-label={`${carat.name} ${price}`}
            data-cy={`stone-weight-${carat.value}`}
            flexBasis="85px"
            key={`d_carat_${carat.value}`}
            mr={1}
            onClick={() => setChoice(carat)}
            role="radio"
            selected={selected}
            tabIndex={focused ? 0 : -1}
            {...(focused && { ref: focusElementRef })}
            {...keyboardProps}
          >
            <OptionTitle mb="4px">{carat.name}</OptionTitle>
            <Image
              alt={carat.value}
              height="48px"
              mb="4px"
              src={`${sl.config.jewlr_asset_url}images/product/diamond/${selectedShape}/${carat.value}ct.svg`}
              width="48px"
            />
            <OptionPrice>{price}</OptionPrice>
          </ChoiceOption>
        )
      })}
    </OptionsSlider>
  )
}
ChoiceOptions.propTypes = {
  caratOptions: PropTypes.array,
  focusElementRef: PropTypes.object,
  selectedCarat: PropTypes.string,
  selectedShape: PropTypes.string,
  setChoice: PropTypes.func,
}
const InternalCaratOptions = ({
  caratOptions,
  selectedCarat,
  selectedShape,
  setChoice,
}) => {
  const focusElementRef = useRef()

  useEffect(() => {
    if (focusElementRef.current) {
      focusElementRef.current.focus()
    }
  }, [])

  return (
    <Box>
      <FocusScope>
        <ChoiceOptions
          caratOptions={caratOptions}
          focusElementRef={focusElementRef}
          selectedCarat={selectedCarat}
          selectedShape={selectedShape}
          setChoice={setChoice}
        />
      </FocusScope>
    </Box>
  )
}

const mapStateToProps = (state) => {
  return {
    caratOptions: state.diamondSelector.d_carat.options,
    selectedCarat: state.choices.d_carat.value,
    selectedShape: state.choices.d_shape.value.toLowerCase(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setChoice: (carat) => {
      dispatch(updateDiamond("d_carat", carat))
    },
  }
}

InternalCaratOptions.propTypes = {
  caratOptions: PropTypes.array,
  selectedCarat: PropTypes.string,
  selectedShape: PropTypes.string,
  setChoice: PropTypes.func,
}

const CaratOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalCaratOptions)

export default CaratOptions
